export const NAME = 'saddleStitchingMachines';